import Tasks from "./Tasks";
import { useTaskOrdering as foobar } from "./useTaskOrdering";
export { updateTask } from "./UpdateTask";

export const useTaskOrdering = foobar;
export default Tasks;
